import React from 'react';
import PropTypes from 'prop-types';

const ListKum = ({
  number, nama, tanggal, nilaiKum,
}) => (
  <>
    <tr>
      <td>{number}</td>
      <td>{nama}</td>
      <td>{tanggal}</td>
      <td>{nilaiKum}</td>
    </tr>
  </>
);

ListKum.defaultProps = {
  number: '',
  nama: '',
  tanggal: '',
  nilaiKum: '',
};

ListKum.propTypes = {
  number: PropTypes.string,
  nama: PropTypes.string,
  tanggal: PropTypes.string,
  nilaiKum: PropTypes.string,
};

export default ListKum;
